import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import { selectAppStoreUrls } from '@shared/store/app/app.selectors';
import { getStoreUrl } from '@utils/capacitor-utils';
import {
  MdcButton,
  MdcDrawer,
  MdcDrawerContent,
  MdcDrawerHeader,
  MdcGrid,
  MdcTypography
} from 'ids-wc/dist/react/components';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import styles from './PromptToUpdateToNewVersion.module.css';
import updatePromptImage from '/update-app.png';

interface PromptToUpdateToNewVersionProps {
  isOpen?: boolean;
}

export const PromptToUpdateToNewVersion = ({ isOpen }: PromptToUpdateToNewVersionProps) => {
  const dialogRef = useRef<HTMLMdcDrawerElement>(null);
  const { t } = useTranslationHelper('updatePromptModal');
  const storeUrls = useSelector(selectAppStoreUrls);

  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.open();
    } else {
      dialogRef.current?.close();
    }
  }, [isOpen]);

  const handleUpdateApp = () => {
    if (storeUrls) {
      const storeUrl = getStoreUrl(storeUrls.ios, storeUrls.android);
      window.open(storeUrl, '_blank');
      dialogRef.current?.close();
    }
  };

  return (
    <MdcDrawer
      ref={dialogRef}
      orientation={'bottom'}
      id="mdcDrawer"
      size="lg"
      drawerTitleId="update-prompt-drawer"
      disableAutoFocus
      className={styles['update-prompt-drawer']}
    >
      <MdcDrawerHeader className={styles['update-prompt-drawer-header']}>
        <MdcGrid row justifyContent="center">
          <img alt="BiometricsImage" src={updatePromptImage} className={styles['update-prompt-image']} />
        </MdcGrid>
      </MdcDrawerHeader>
      <MdcDrawerContent>
        <MdcGrid row>
          <MdcGrid col={12}>
            <MdcTypography text={t('title')} variant="headline3" color="textPrimary" textAlign="left" />
          </MdcGrid>

          <MdcGrid col={12}>
            <MdcTypography text={t('description')} variant="body1" color="textPrimary" textAlign="left" />
          </MdcGrid>

          <MdcGrid col={12}>
            <MdcButton
              onClick={handleUpdateApp}
              label={t('update')}
              color="primary"
              fullWidth
              disableFocusRing
              style={{ marginBlockEnd: 5 }}
            />
            <MdcButton
              onClick={() => dialogRef.current?.close()}
              label={t('later')}
              color="primary"
              variant="tertiary"
              fullWidth
              disableFocusRing
            />
          </MdcGrid>
        </MdcGrid>
      </MdcDrawerContent>
    </MdcDrawer>
  );
};
